import { urlWithQuery } from '~/utils/url';
import { BaseRestRepository } from './baseRestRepository';
import type { AddServiceBillDto, AdjustServiceBillDto, ServiceBillDto, ServiceBillPaginationDto } from '~/swagger/portal/Api';
import type { ApiFilter } from '~/types/apiFilters';

const BILLS_URL = '/api/service-bills';

export class ServiceBillRepository extends BaseRestRepository {
  public async addServiceBill(data: AddServiceBillDto): Promise<ServiceBillDto> {
    const url = `${BILLS_URL}`;
    const response = await this.fetchWithAuth(url, { method: 'POST', body: JSON.stringify(data) });
    return await this.getJsonResponse(response);
  }

  public async getServiceBills(filters: ApiFilter): Promise<ServiceBillPaginationDto> {
    const url = BILLS_URL;
    const response = await this.fetchWithAuth(urlWithQuery(url, filters));
    return this.getJsonResponse(response);
  }

  public async getServiceBill(serviceBillId: string): Promise<ServiceBillDto> {
    const url = `${BILLS_URL}/${serviceBillId}`;
    const response = await this.fetchWithAuth(url, { method: 'GET' });
    return this.getJsonResponse(response);
  }

  public async updateServiceBill(serviceBillId: string, data: AdjustServiceBillDto): Promise<ServiceBillDto> {
    const url = `${BILLS_URL}/${serviceBillId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return this.getJsonResponse(response);
  }

  public async deleteServiceBill(serviceBillId: string) {
    const url = `${BILLS_URL}/${serviceBillId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
